import React from 'react';

export const textStyles:React.CSSProperties = {
  fontSize: '12px',
  fontWeight: 600,
  marginLeft: '8px',
};
